/**
 * 확장 지연 모듈 로더 (ADR 0024)
 * --------------------------------------------------------------------------
 * **저장소에서 동적 import가 허용되는 유일한 파일**입니다. 지정자는 매니페스트가
 * 선언한 리터럴과 정확히 같아야 하며, 변수·템플릿·URL 지정자는 빌드 검사
 * (`packages/extensions/scripts/check-bundle.mjs`)가 거절합니다.
 *
 * 런타임에 URL이나 파일에서 JavaScript를 가져오는 경로는 이 프로젝트에 없습니다.
 * 확장은 저장소에 있는 코드이고, 여기서 **언제 불러올지만** 늦춥니다.
 */

/** 지연 모듈의 export 묶음. 어떤 export가 컴포넌트인지는 registry가 확인합니다. */
export type ExtensionModuleExports = Record<string, unknown>;

export const EXTENSION_LOADERS: Readonly<Record<string, () => Promise<ExtensionModuleExports>>> = {
  "@/features/logs/LogsExplorer": () => import("@/features/logs/LogsExplorer"),
};
